<template>
  <div class="enhanced-qr-container">
    <div class="qr-wrapper" :style="wrapperStyle">
      <canvas ref="qrCanvas"></canvas>
    </div>
  </div>
</template>

<script>
// Importante: Para usar este componente, será necessário instalar a biblioteca QRCode.js
// npm install qrcode
import QRCode from 'qrcode'

export default {
  name: 'EnhancedQrCode',
  props: {
    value: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 200
    },
    margin: {
      type: Number,
      default: 20
    },
    color: {
      type: String,
      default: '#000000'
    },
    backgroundColor: {
      type: String,
      default: '#FFFFFF'
    },
    errorCorrectionLevel: {
      type: String,
      default: 'H',
      validator: (value) => ['L', 'M', 'Q', 'H'].includes(value)
    },
    borderWidth: {
      type: Number,
      default: 10
    },
    borderColor: {
      type: String,
      default: '#FFFFFF'
    },
    borderRadius: {
      type: Number,
      default: 8
    }
  },
  
  computed: {
    wrapperStyle() {
      return {
        padding: `${this.borderWidth}px`,
        backgroundColor: this.borderColor,
        borderRadius: `${this.borderRadius}px`
      }
    }
  },
  
  watch: {
    value: 'generateQrCode',
    size: 'generateQrCode',
    margin: 'generateQrCode',
    color: 'generateQrCode',
    backgroundColor: 'generateQrCode',
    errorCorrectionLevel: 'generateQrCode'
  },
  
  mounted() {
    this.generateQrCode()
  },
  
  methods: {
    generateQrCode() {
      if (!this.value) return
      
      const options = {
        width: this.size,
        margin: this.margin,
        color: {
          dark: this.color,
          light: this.backgroundColor
        },
        errorCorrectionLevel: this.errorCorrectionLevel
      }
      
      QRCode.toCanvas(this.$refs.qrCanvas, this.value, options, (error) => {
        if (error) {
          this.$emit('error', error)
        }
      })
    }
  }
}
</script>

<style scoped>
.enhanced-qr-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
}

.qr-wrapper {
  display: inline-block;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  background-color: white;
  
  /* Forçar fundo branco mesmo em temas escuros */
  color-scheme: light;
  forced-color-adjust: none;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

/* Adicionar compatibilidade específica para temas escuros */
@media (prefers-color-scheme: dark) {
  .qr-wrapper {
    background-color: white !important;
    border: 2px solid white !important;
  }
}
</style> 